import { cn } from "@/lib/utils";
import avatarLuna from "@/assets/avatar-luna.png";

interface LunaAvatarProps {
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
}

const sizeMap = {
  sm: "w-8 h-8",
  md: "w-12 h-12",
  lg: "w-16 h-16",
  xl: "w-20 h-20 sm:w-24 sm:h-24",
};

export const LunaAvatar = ({ size = "md", className }: LunaAvatarProps) => {
  return (
    <div
      className={cn(
        "relative rounded-full overflow-hidden shrink-0 bg-cyan-light",
        "shadow-[0_8px_24px_-6px_hsl(var(--cyan-dark)/0.4)]",
        "ring-2 ring-white/80",
        sizeMap[size],
        className
      )}
    >
      <img
        src={avatarLuna}
        alt="Luna AI Coach"
        loading="lazy"
        width={1024}
        height={1024}
        className="w-full h-full object-cover"
      />
      <span className="absolute bottom-0 right-0 w-3 h-3 rounded-full bg-yellow border-2 border-white animate-pulse" />
    </div>
  );
};
